// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3yrnV","requiredAsterisk":"Info_requiredAsterisk__32iyJ"};